import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import { notification } from "antd";
import returnDataAccess from "src/dataAccess/returns/returnDataAccess";
import policiesDataAccess from "src/dataAccess/policies/policiesDataAccess";
import mixesDataAccess from "src/dataAccess/mixes/mixesDataAccess";

export const LoadingData = createAction<boolean>("[Mixes] Loading data");
export const loadingList = createAction<boolean>("[Mixes] Loading list");

export const getMixesListSuccess = createAction<any>(
  "[Mixes] Get Mixes List Success",
);
export const getMixesListAsync = createAsyncThunk<any, IListType>(
  "[Mixes] Get Mixes List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await mixesDataAccess.mixList(parameter).then((res) => {
      thunkAPI.dispatch(getMixesListSuccess(res));
      thunkAPI.dispatch(loadingList(false));
      return res;
    });
    return result;
  },
);

export const saveMixesListSuccess = createAction<any>(
  "[Mixes] Save Mixes List Success",
);

export const deleteMixesAsync = createAsyncThunk<any, number | number[]>(
  "[Mixes] Delete Mixes(s)",
  async (mixesIdOrIds, thunkAPI) => {
    const idsToDelete: number[] = Array.isArray(mixesIdOrIds)
      ? mixesIdOrIds
      : [mixesIdOrIds];
    await mixesDataAccess.deleteMix(idsToDelete);
    const count = idsToDelete.length;
    const message = `${count} mixes${count === 1 ? "" : "es"} deleted successfully`;

    notification.success({ message });
    thunkAPI.dispatch(deleteMixesSuccess(idsToDelete));
    return idsToDelete;
  },
);

export const deleteMixesSuccess = createAction<number[]>(
  "[Mixes] Delete Mixes Success",
);

export const getCompletedMixListSuccess = createAction<any>(
  "[Mixes] Get Completed Mixes List Success",
);
export const getCompletedMixListAsync = createAsyncThunk<any, IListType>(
  "[Mixes] Get Completed Mixes List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await mixesDataAccess
      .completedMixList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getCompletedMixListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  },
);

export const setProcedureId = createAction<any>("[Mixes] Set ProcedureId");

export const getProductMixListSuccess = createAction<any>(
  "[Mixes] Get Products Mixes List Success",
);
export const getProductMixListAsync = createAsyncThunk<any, IListType>(
  "[Mixes] Get Products Mixes List",
  async (parameter, thunkAPI) => {
    thunkAPI.dispatch(loadingList(true));

    const result = await mixesDataAccess
      .productsMixList(parameter)
      .then((res) => {
        thunkAPI.dispatch(getProductMixListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
    return result;
  },
);
